<div [class.app-shell]="showShell">
  <ng-container *ngIf="showShell">
    <app-sidebar class="hide-mobile"></app-sidebar>
    <div class="app-main">
      <app-topbar></app-topbar>
      <main class="app-content animate-fade-in">
        <router-outlet></router-outlet>
      </main>
    </div>
    <app-bottom-nav class="hide-desktop"></app-bottom-nav>
  </ng-container>
  <ng-container *ngIf="!showShell">
    <router-outlet></router-outlet>
  </ng-container>
</div>
<app-toast></app-toast>
